import { render } from "./ProductRefillsetSkeleton.vue?vue&type=template&id=7c4a54ff"
import script from "./ProductRefillsetSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductRefillsetSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__